import { useEffect, useRef } from "react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

const AMIENS = [49.8941, 2.2958];
const fmt = (n) => new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR", maximumFractionDigits: 0 }).format(n);

function goldPin() {
  return L.divIcon({
    className: "sd-pin",
    html: `<span style="display:block;width:22px;height:22px;border-radius:50% 50% 50% 0;background:#D4AF37;border:2px solid #060B19;transform:rotate(-45deg);box-shadow:0 4px 10px rgba(0,0,0,.5)"></span>`,
    iconSize: [22, 22],
    iconAnchor: [11, 22],
    popupAnchor: [0, -22],
  });
}

// listings: array with lat/lng. If single=true, no popups, just centered marker.
export default function MapView({ listings = [], height = 420, single = false, zoom }) {
  const ref = useRef(null);
  const mapRef = useRef(null);

  useEffect(() => {
    if (!ref.current || mapRef.current) return;
    const map = L.map(ref.current, { scrollWheelZoom: false, attributionControl: true });
    mapRef.current = map;
    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
      attribution: '© <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
      maxZoom: 19,
    }).addTo(map);
    return () => { map.remove(); mapRef.current = null; };
  }, []);

  useEffect(() => {
    const map = mapRef.current;
    if (!map) return;
    map.eachLayer((layer) => { if (layer instanceof L.Marker) map.removeLayer(layer); });

    const pts = listings
      .filter((l) => l.lat && l.lng)
      .map((l) => {
        const m = L.marker([l.lat, l.lng], { icon: goldPin() }).addTo(map);
        if (!single) {
          m.bindPopup(
            `<div style="font-family:Manrope,sans-serif;min-width:160px">
               <strong style="color:#0b1020">${l.title}</strong><br/>
               <span style="color:#D4AF37;font-weight:700">${fmt(l.price)}${l.transaction === "location" ? " /mois" : ""}</span><br/>
               <span style="color:#555">${l.city} · ${l.surface} m²</span><br/>
               <a href="/annonces/${l.id}" style="color:#0b62d6;font-weight:600">Voir le bien →</a>
             </div>`
          );
        }
        return [l.lat, l.lng];
      });

    if (pts.length === 1) {
      map.setView(pts[0], zoom || 14);
    } else if (pts.length > 1) {
      map.fitBounds(pts, { padding: [40, 40] });
    } else {
      map.setView(AMIENS, zoom || 12);
    }
    setTimeout(() => map.invalidateSize(), 100);
  }, [listings, single, zoom]);

  return <div ref={ref} data-testid="map-view" style={{ height, width: "100%", borderRadius: 24, zIndex: 0 }} className="sd-map border border-white/10" />;
}
